<template lang="pug">
.send-message-target-modal
  b-modal(v-model="_show" size="lg" @ok="add" @cancel="cancel")
    template(#modal-header="{ cancel }")
      .send-message-target-modal-header.d-flex.flex-row.align-items-center
        span.menu-title.flex-grow-1 宛先を選択してください。
      button.close(type="button" @click="cancel") ×

    .send-message-target-modal-body
      //- group name, group member name filter
      .mb-2.d-flex.flex-row.align-items-center
        b-form-input(id="text-filter" v-model="filter.text" name="text-filter" placeholder="グループを検索" aria-describedby="text-filter" data-vv-as="テキスト検索")
      //- list
      b-list-group
        template(v-if="groupType.show == true" v-for="groupType in _value")
          b-list-group-item.list-group-title
            span {{ groupType.name }}
          b-list-group-item(v-if="group.show == true" v-for="group in groupType.targets" :key="groupType.type + group.id")
            b-form-checkbox(v-model="group.isTarget" size="sm"
              :class="{ 'disable': group.memberCount <= 0 }" :disabled="group.memberCount <= 0"
              @change="checkGroup(groupType.type)") {{ group.name }}（{{ group.memberCount }}人）

    template(#modal-footer="{ ok, cancel }")
      b-button.btn.modal-ok-btn(type="button" @click="ok()") OK
      b-button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SendMessageGroupsGetModel } from "@/commons/services/SendMessageGroups";
import { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import OtherUserGroup from "@/commons/models/OtherUserGroup";

/**
 * 宛先リストモーダル
 */
@Component
export default class SafetyConfirmTargetMessageGroupModal extends Vue {
  /** ### 宛先候補 */
  @Prop()
  value!: Array<SafetyConfirmTargetMessageGroupModalModel>;
  /** ### 表示可否 */
  @Prop()
  show!: boolean;
  /** 現在選択されている宛先グループ種別 */
  @Prop()
  selectedGroupType!: TargetType;

  /** フィルタ */
  filter: { text: string } = { text: "" };

  get _value(): Array<SafetyConfirmTargetMessageGroupModalModel> {
    // テキスト検索==空の場合は全て表示する
    if (this.filter.text == "") {
      for (const group of this.value) {
        group.show = true;
        for (const target of group.targets) {
          target.show = true;
        }
      }
    }
    // テキスト検索!=空の場合はキーワードでフィルタリングして表示する
    else if (this.filter.text != "") {
      const words: string[] = this.$filterUtil.createSearchWord(this.filter.text);
      for (const group of this.value) {
        let groupShow: boolean = false;
        for (const target of group.targets) {
          for (const word of words) {
            if (-1 < target.name.indexOf(word)) {
              target.show = true;
              groupShow = true;
              break;
            }
            if (-1 < target.name.indexOf(word)) {
              target.show = true;
              groupShow = true;
              break;
            }
            target.show = false;
          }
        }
        group.show = groupShow;
      }
    }

    return this.value;
  }

  get _show(): boolean {
    return this.show;
  }

  set _show(newValue: boolean) {
    this.$emit("update:show", newValue);
    return;
  }

  get _checked(): boolean {
    for (const group of this.value) {
      for (const target of group.targets) {
        if (target.isTarget == true) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * ### グループのクリックイベント
   *
   * - 別のグループ種別が選択されたら既に選択されているグループ種別の内容をリセットする
   */
  public checkGroup(selectedGroupType: TargetType): void {
    if (this.selectedGroupType == TargetType.NONE) {
      this.$emit("update:selectedGroupType", selectedGroupType);
      return;
    }
    if (this.selectedGroupType == selectedGroupType) {
      return;
    }

    this.$emit("update:selectedGroupType", selectedGroupType);
    for (const groupType of this.value) {
      if (groupType.type == selectedGroupType) {
        continue;
      }
      for (let group of groupType.targets) {
        group.isTarget = false;
      }
    }

    return;
  }

  /**
   * ### OKボタン押下イベント
   */
  public add(): void {
    this.$emit("add");
    return;
  }

  /**
   * ### キャンセルボタン押下イベント
   *
   */
  public cancel(): void {
    this.filter.text = "";
    this.$emit("cancel");
    return;
  }
}

export interface SafetyConfirmTargetMessageGroupModalModel {
  name: string;
  targets: Array<SafetyConfirmTargetMessageGroupModel | SafetyConfirmTargetResidentGroupModel | SafetyConfirmTargetOtherUserGroupModel>;
  show: boolean;
  type: TargetType;
}
export interface SafetyConfirmTargetMessageGroupModel extends SendMessageGroupsGetModel {
  isTarget: boolean;
  show: boolean;
  memberCount: number;
}
export interface SafetyConfirmTargetResidentGroupModel extends ResidentGroupsGetModel {
  isTarget: boolean;
  show: boolean;
  memberCount: number;
}
export interface SafetyConfirmTargetOtherUserGroupModel extends OtherUserGroup {
  isTarget: boolean;
  show: boolean;
  memberCount: number;
}
export enum TargetType {
  NONE = "",
  SEND_MESSAGE_GROUP_FOR_FAMILY = "sendMessageGroupForFamily",
  SEND_MESSAGE_GROUP_FOR_OTHER_USER = "sendMessageGroupForOtherUser",
  RESIDENT_GROUP = "residentGroup",
  OTHER_USER_GROUP = "otherUserGroup"
}
</script>

<style lang="scss" scopeed>
@import "../../../styles/mobile/_colors.scss";

.send-message-target-modal-body {
  .list-group-title {
    color: $font-accordion !important;
    background-color: $bg-accordion !important;
  }
}
</style>
